import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// The in-flow counterpart to BlockingOverlay. It fills whatever container it is given
// and nothing more: a modal body, a dropdown, a list region. Reads use this. Only
// writes that must not be fired twice get the overlay.
export default function InlineLoader() {
    return (
        <Box
            data-testid='inline-loader'
            display='flex'
            justifyContent='center'
            alignItems='center'
            width='100%'
            minHeight='120px'
        >
            <CircularProgress />
        </Box>
    );
}
